export const sxStyle = {
  sectionTitle: {
    fontSize: { xs: '18px', sm: '20px' },
    color: '#000000',
    fontWeight: 600,
    mt: '2vh',
    mb: '2vh',
  },
};
